import { signInWithPasswordIdentifier as originalSignInWithPassword } from 'monoai:original?apis/experience/index';

import { beginSignInAttempt } from '@/utils/last-sign-in-method';

export * from 'monoai:original?apis/experience/index';

export async function signInWithPasswordIdentifier(
  ...args: Parameters<typeof originalSignInWithPassword>
) {
  beginSignInAttempt('password');
  return originalSignInWithPassword(...args);
}
